export enum CardStyle {
  LIGHT_GREY = 'Light_Grey',
  LIGHT_BLUE = 'Light_Blue',
  LIGHT_PINK = 'Light_Pink',
  LIGHT_PURPLE = 'Light_Purple',
  TRANSPARENT = 'Transparent',
  WHITE_WITH_BORDER = 'White_With_Border',
  WIDE_WHITE_WITH_BORDER = 'Wide_White_With_Border',
  PROFILE_STYLE = 'Profile_Style',
  SMALL_WHITE_CARD = 'Small_White_Card',
  HORIZONTAL_IMAGE_TEXT = 'Horizontal_Image_Text',
  AWARD_QUOTE = 'Award_Quote',
}
